import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";

export const serviceCategoryFields = `
id
categoryUniqueId
categoryName
categoryCode
categoryDescription
`


export const GET_SERVICE_CATEGORIES = gql`
query GetServiceCategories($filtering: ServiceCategoryFilteringInputObjects) {
  getServiceCategories(filtering: $filtering) {
    ${baseResponseGraphqlField}
    data {
      ${serviceCategoryFields}
    }
  }
}
`

export const CREATE_SERVICE_CATEGORY = gql`
mutation CreateServiceCategoryMutation($input: ServiceCategoryInputObjects!) {
  createServiceCategoryMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${serviceCategoryFields}
    }
  }
}
`

export const UPDATE_SERVICE_CATEGORY = gql`
mutation UpdateServiceCategoryMutation($input: ServiceCategoryInputObjects) {
  updateServiceCategoryMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${serviceCategoryFields}
    }
  }
}
`

export const DELETE_SERVICE_CATEGORY = gql`
mutation DeleteServiceCategoryMutation($categoryUniqueId: String!) {
  deleteServiceCategoryMutation(categoryUniqueId: $categoryUniqueId) {
    ${baseResponseGraphqlField}
  }
}
`
